import { Box, Flex, Group, Tooltip, useMantineTheme } from '@mantine/core';
import { Icon2fa, IconKeyOff } from '@tabler/icons-react';
import { UserRow } from 'components/tables/data/user/types';
import BadgeDeleted from 'components/Badge';
import UserContact from 'components/UserContact';

/**
 * Column for the full name.
 */
export default function FullNameColumn({
  data: { firstName, lastName, email, status, twoFactorEnabled, passwordValidUntil },
}: {
  data: UserRow;
}) {
  const theme = useMantineTheme();

  const opacity = status ? 1 : 0.6;
  const passwordValidUntilTimestamp = passwordValidUntil ? new Date(passwordValidUntil).getTime() : Number.NaN;
  const hasExpiredPassword = Number.isFinite(passwordValidUntilTimestamp) && passwordValidUntilTimestamp <= Date.now();

  return (
    <Flex gap={10} align="center">
      {!status && <BadgeDeleted text="Vyradený" />}
      <Box style={{ opacity }}>
        <UserContact
          firstName={firstName}
          lastName={lastName}
          email={email}
          nameAdornment={
            twoFactorEnabled || hasExpiredPassword ? (
              <Group spacing={4} noWrap>
                {twoFactorEnabled && (
                  <Tooltip label="Dvojfaktorové overenie je zapnuté">
                    <Icon2fa color={theme.colors.blue[8]} size={18} stroke={2} />
                  </Tooltip>
                )}
                {hasExpiredPassword && (
                  <Tooltip label="Platnosť hesla vypršala">
                    <IconKeyOff color={theme.colors.red[7]} size={18} stroke={2} />
                  </Tooltip>
                )}
              </Group>
            ) : undefined
          }
        />
      </Box>
    </Flex>
  );
}
